export const QUERY_PARAM_COMPARE_ITEMS = 'compare-items';